import { render, staticRenderFns } from "./ExcelTable.vue?vue&type=template&id=04160ba5&scoped=true"
import script from "./ExcelTable.vue?vue&type=script&lang=js"
export * from "./ExcelTable.vue?vue&type=script&lang=js"
import style0 from "./ExcelTable.vue?vue&type=style&index=0&id=04160ba5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04160ba5",
  null
  
)

export default component.exports